import { render } from "./Services.vue?vue&type=template&id=5369bf56&scoped=true&ts=true"
import script from "./Services.ts?vue&type=script&lang=ts&external"
export * from "./Services.ts?vue&type=script&lang=ts&external"

import "./Services.vue?vue&type=style&index=0&id=5369bf56&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5369bf56"]])

export default __exports__